import styled from 'styled-components'

export const TagsStyle = styled.div`
  .sora {
    font-family: 'Sora';
  }
`
